import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { Identifier, useNotify, useRecordContext, useRedirect, useUpdate } from "react-admin";
import { FieldValues } from "react-hook-form";
import { useParams } from "react-router-dom";
import { FranceGroupTypeEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";

export const useGroupEdit = () => {
  const [error, setError] = useState<AxiosError | null>(null);
  const { id: group_id } = useParams() as { id: Identifier };
  const notify = useNotify();
  const [update, { isLoading }]: any = useUpdate();
  const redirect = useRedirect();
  const record = useRecordContext();

  const handleSubmit = useCallback(
    async (data: FieldValues) => {
      setError(null);

      const payload = data.type === FranceGroupTypeEnum.rte_edr ? { ...data, group_data: record?.group_data } : data;

      update(
        SiteResourcesEnum.Groups,
        { id: group_id, data: payload },
        {
          onSuccess: ({ id }: any) => {
            notify("Group updated successfully", { type: "success" });
            redirect(`/${SiteResourcesEnum.Groups}/${id}/show`);
          },
          onError: (error: any) => {
            notify("Error updating group", { type: "error" });
            setError(error);
          },
        },
      );
    },
    [group_id, update, redirect, notify, setError, record],
  );

  return { error, isLoading, handleSubmit };
};
